import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';






import { NavbarModule } from 'app/layout/components/navbar/navbar.module';

import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { VerticalLayout2Component } from 'app/layout/vertical/layout-2/layout-2.component';

@NgModule({
    imports: [
    RouterModule,
    NavbarModule,
    ToolbarModule,
    VerticalLayout2Component
],
    exports: [
        VerticalLayout2Component
    ]
})
export class VerticalLayout2Module
{
}
